export default __webpack_public_path__ + "static/media/Mobile-Exchange.05620d7a.png";